// extracted by mini-css-extract-plugin
export default {"container":"DeleteActivitiesConfirmationModal_container__SLmVb","description":"DeleteActivitiesConfirmationModal_description__mxLiK"};